<template>
  <div class="style-container style-container-shadow mt-4">
    <div class="d-flex flex-column">
      <div class="">
        <!-- Image -->
        <div class="style-img-container">
          <smart-image
            :imageURL="purchaseItem?.product?.image"
            class="style-img"
          />
        </div>
        <!-- Content -->
        <div class="w-75 text-start p-3 d-flex flex-column style-content">
          <span class="scss-bold" v-if="purchaseItem.product.name">{{
            purchaseItem.product.name
          }}</span>
          <span
            class="scss-overflow-text-style style-date"
            v-if="purchaseItem.date"
            >Purchased: {{ purchaseItem.date }}
          </span>
          <span
            class="scss-overflow-text-style style-date"
            v-if="purchaseItem.lastConsumed"
            >Last Consumed: {{ purchaseItem.lastConsumed }}
          </span>
          <span class="scss-overflow-text-style style-date"
            >Last Redeemed:
            {{
              purchaseItem.prepaidUse.length !== 0
                ? formatDate(purchaseItem?.prepaidUse[0]?.date)
                : "-"
            }}
          </span>
          <span
            class="scss-overflow-text-style style-date"
            v-if="purchaseItem.expiryDate"
            >Expiry: {{ formatExpiryDate(purchaseItem.expiryDate) }}
          </span>
          <span
            class="scss-overflow-text-style style-duration"
            v-if="purchaseItem.duration"
            >Duration: {{ purchaseItem.duration }}</span
          >
        </div>
        <div
          class="style-rotate d-flex justify-content-center align-items-center"
        >
          <div class="style-disable-button" @click="goToAppointment">
            Redeem in Shop
          </div>
        </div>
      </div>
    </div>

    <!-- Remaining Sessions & Action -->
    <div
      class="style-action-container d-flex flex-row text-start"
      v-if="purchaseItem.unit"
    >
      <span class="scss-text-ligh-blue ps-4 style-remaining-session my-auto"
        >{{ purchaseItem.unitRemain }}/{{ purchaseItem.unit }}</span
      >
      <div class="style-remaining-session-title my-auto ms-2">
        <span class="scss-small-font"
          >Credits <br />
          remaining</span
        >
      </div>
    </div>
  </div>
</template>

<script>
import SmartImage from "@/components/SmartImage.vue";
import { convertDateFormat } from "@/common/helpers/DateTimeHelper";

export default {
  name: "CreditItem",
  components: { SmartImage },
  props: {
    purchaseItem: Object,
  },
  methods: {
    formatDate(date) {
      return convertDateFormat(date);
    },
    formatExpiryDate(date) {
      if (date === "1899-11-30") {
        return "-";
      }
      return date;
    },
  },
};
</script>

<style scoped lang="scss">
/* New Style */
.style-container {
  border: 1px solid #dadada;
  border-right: none;
  border-bottom: none;
  width: 90%;
  margin: 0 auto 0 auto;
  height: fit-content;
  border-radius: 10px;
  overflow: hidden;
  position: relative;
}

.style-container-shadow {
  box-shadow: 1px 2px $border-light-grey;
}

.style-img {
  object-fit: cover;
  width: 100%;
  height: 100%;
  min-height: 100px;
  max-height: 150px;
}

.style-content {
  font-size: 12px;
  line-height: 24px;
}

.style-action-container {
  height: 60px;
  border-top: 1px solid $border-light-grey;
}

.style-book-button {
  background-color: $text-blue;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.style-book-button:hover {
  opacity: 0.8;
}

.style-book-button:hover {
  opacity: 0.8;
}

.style-book-button:active {
  box-shadow: 3px 2px 22px 1px rgba(134, 134, 134, 0.24);
  transform: scale(1.01, 1.01);
}

.style-disable-button {
  background-color: $text-light-color;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
}

/* For PC */
// @media screen and (min-width: 494px) {
.style-rotate {
  position: absolute;
  right: 10px;
  top: 210px;
}

.style-disable-button {
  height: 50px;
  width: 150px;
}
// }

// @media screen and (min-width: 300px) and (max-width: 494px) {
//   .style-rotate {
//     position: absolute;
//     right: 10px;
//     top: 190px;
//   }

//   .style-disable-button {
//     height: 45px;
//     width: 140px;
//   }
// }

/* For Mobile */
@media screen and (max-width: 450px) {
  .style-disable-button {
    height: 45px;
    width: 100px;
    font-size: 12px;
  }

  .style-rotate {
    top: 215px;
  }
}

.style-description {
  max-height: 75px;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.style-remaining-session {
  font-size: 40px;
}

.style-remaining-session-title {
  line-height: 15px;
}
</style>
